var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThunderbolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.371 5.793L6.372.5.167 7.973H3.97L2.068 13.5l7.107-7.707H5.37z",
    fill: "#7539C1"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/icons/thunderbolt-fb72cb34f2309eac7299c15dc2834f18.svg";
export { SvgThunderbolt as Component };